/* One compact viewer: load only the selected film, with original audio on demand. */
(() => {
  const root=document.querySelector('.craft-viewer');if(!root)return;
  const video=root.querySelector('video'),still=root.querySelector('.craft-still'),screen=root.querySelector('.craft-screen');
  const tabs=[...root.querySelectorAll('[data-craft-group]')],choices=root.querySelector('.craft-choices');
  const choiceTitle=root.querySelector('.craft-choice-title'),choiceCount=root.querySelector('.craft-choice-count');
  const controls=root.querySelector('.craft-controls'),play=root.querySelector('.craft-play'),sound=root.querySelector('.craft-sound'),mute=root.querySelector('.craft-mute');
  const range=root.querySelector('input'),time=root.querySelector('.craft-time'),status=root.querySelector('.craft-status');
  const title=root.querySelector('.craft-caption h3'),note=root.querySelector('.craft-caption p');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const clips={
    packing:{title:'Taylans Bestellung',label:'Persönlich verpackt',group:'packing',note:'Originalaufnahme · 1 Minute'},
    box:{title:'Ein besonderer Moment',label:'Die Präsentationsbox',group:'packing',note:'Mit Higgsfield inszeniert · 12 Sekunden'},
    dial:{title:'Am Werktisch',label:'Das Ziffernblatt',group:'making',note:'Originalaufnahme · Handmontage'},
    assembly:{title:'Ein Handgriff. Mit Gefühl.',label:'Die Zeiger setzen',group:'making',note:'Originalaufnahme · Handmontage'},
    cutaway:{title:'Ein Blick ins Innere',label:'Die Uhr im Schnitt',group:'making',note:'Schematische Darstellung · nicht maßstabsgetreu',image:true},
    'botan-rose':{title:'Botan in Roségold',label:'Botan · Roségold',group:'watches',note:'Originalaufnahme · rund um die Uhr'},
    'botan-silver':{title:'Botan in Silber',label:'Botan · Silber',group:'watches',note:'Originalaufnahme · rund um die Uhr'},
    roj:{title:'Roj in Roségold',label:'Roj · Roségold',group:'watches',note:'Originalaufnahme · feine Proportionen'},
    welat:{title:'Welat in Silber',label:'Welat · Silber',group:'watches',note:'Originalaufnahme · klassisch in Silber'}
  };
  let key='packing',visible=false,near=false,userPaused=false,loaded=false,pendingPlay=false,audioPromptSeen=false,manualPlay=false,playGeneration=0;
  const resume=document.createElement('button');resume.type='button';resume.className='craft-resume';resume.textContent='Aufnahme abspielen';resume.setAttribute('aria-controls','craft-film');resume.hidden=true;screen.append(resume);
  const lastChoice={packing:'packing',making:'dial',watches:'botan-rose'};
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  function syncPlay(){
    if(!visible||document.hidden||userPaused||(reduced.matches&&!manualPlay)||!loaded||clips[key].image){video.pause();return;}
    if(!video.paused||pendingPlay)return;
    requestPlay();
  }
  function requestPlay(){
    const generation=playGeneration;
    pendingPlay=true;
    video.play().catch(()=>{
      if(generation===playGeneration&&visible&&!clips[key].image){resume.hidden=false;sound.hidden=true;screen.classList.remove('is-loading');}
    }).finally(()=>{if(generation===playGeneration)pendingPlay=false;});
  }
  function startManually(){
    manualPlay=true;userPaused=false;
    if(!loaded||video.error){loaded=false;load();}
    requestPlay();
  }
  resume.addEventListener('click',startManually);
  function updateControls(){
    play.classList.toggle('is-playing',!video.paused);play.setAttribute('aria-label',video.paused?'Aufnahme abspielen':'Aufnahme pausieren');
    resume.hidden=clips[key].image||!video.paused||!visible;
    sound.hidden=!resume.hidden||audioPromptSeen||clips[key].image||!loaded||video.readyState<2;
    mute.hidden=!audioPromptSeen||clips[key].image;
    mute.setAttribute('aria-label',video.muted?'Ton einschalten':'Ton ausschalten');
    mute.classList.toggle('is-muted',video.muted);
  }
  function load(){
    if(loaded||clips[key].image)return;
    const id=key;
    const mobile=matchMedia('(max-width:700px)').matches&&['assembly','botan-rose','botan-silver','welat','roj'].includes(id);
    screen.classList.add('is-loading');status.textContent='';
    loaded=true;video.preload='auto';
    video.src=id==='packing'&&video.dataset.packingSrc?video.dataset.packingSrc:window.KM.asset(`./assets/craft/${id}${mobile?'-mobile':''}.mp4${id==='box'?'?v=20':''}`);
    video.load();
  }
  function showChoices(id){
    const group=clips[id].group,entries=Object.entries(clips).filter(([,clip])=>clip.group===group);
    choiceTitle.textContent=group==='watches'?'Uhr auswählen & ansehen':'Aufnahme auswählen';
    choiceCount.textContent=`${entries.findIndex(([value])=>value===id)+1} / ${entries.length}`;
    if(choices.dataset.group!==group){
      choices.dataset.group=group;choices.style.setProperty('--choice-count',entries.length);
      choices.replaceChildren(...entries.map(([value,clip])=>{
        const button=document.createElement('button');button.type='button';button.className='craft-choice';button.dataset.craftClip=value;
        button.setAttribute('aria-label',`${clip.label} ansehen`);button.setAttribute('aria-controls',clip.image?'craft-cutaway':'craft-film');
        const thumb=document.createElement('span');thumb.className='craft-choice-thumb';
        const image=document.createElement('img');image.src=window.KM.asset(`./assets/craft/${value}.${clip.image?'png':'webp'}${value==='box'?'?v=20':''}`);image.alt='';image.decoding='async';
        const icon=document.createElement('span');icon.className='craft-choice-icon';icon.setAttribute('aria-hidden','true');icon.textContent=clip.image?'+':'▶';
        thumb.append(image,icon);
        const label=document.createElement('span');label.className='craft-choice-label';
        const [name,finish]=clip.label.split(' · ');label.textContent=name;
        if(finish){const detail=document.createElement('small');detail.textContent=finish;label.append(detail);}
        button.append(thumb,label);return button;
      }));
    }
    choices.querySelectorAll('[data-craft-clip]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.craftClip===id)));
  }
  function choose(id){
    if(!clips[id])return;
    playGeneration++;key=id;loaded=false;userPaused=false;manualPlay=false;pendingPlay=false;video.pause();
    video.controls=false;
    if(clips[id].image){video.removeAttribute('src');video.load();}
    video.hidden=!!clips[id].image;still.hidden=!clips[id].image;controls.hidden=!!clips[id].image;
    screen.classList.toggle('is-still',!!clips[id].image);screen.classList.remove('is-loading');status.textContent='';
    title.textContent=clips[id].title;note.textContent=clips[id].note;root.dataset.clip=id;
    root.dispatchEvent(new CustomEvent('craftclipchange',{detail:{clip:id}}));
    video.setAttribute('aria-label',clips[id].title);video.poster=window.KM.asset(`./assets/craft/${id}.webp${id==='box'?'?v=20':''}`);range.value=0;time.textContent='0:00';
    const group=clips[id].group;tabs.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.craftGroup===group)));
    lastChoice[group]=id;showChoices(id);
    if(near||visible)load();updateControls();
  }
  tabs.forEach(button=>button.addEventListener('click',()=>{if(clips[key].group!==button.dataset.craftGroup)choose(lastChoice[button.dataset.craftGroup]);}));
  choices.addEventListener('click',event=>{const button=event.target.closest('[data-craft-clip]');if(button){if(button.dataset.craftClip!==key)choose(button.dataset.craftClip);else if(!clips[key].image)startManually();}});
  video.addEventListener('loadeddata',()=>{screen.classList.remove('is-loading');status.textContent='';updateControls();syncPlay();});
  video.addEventListener('canplay',syncPlay);
  video.addEventListener('playing',()=>{screen.classList.remove('is-loading');status.textContent='';video.controls=false;updateControls();});
  video.addEventListener('play',updateControls);video.addEventListener('pause',updateControls);
  video.addEventListener('volumechange',updateControls);
  video.addEventListener('error',()=>{if(loaded&&video.error){loaded=false;pendingPlay=false;screen.classList.remove('is-loading');status.textContent='Die Aufnahme konnte nicht geladen werden. Tippe auf die Abspieltaste, um es erneut zu versuchen.';video.controls=true;updateControls();}});
  const format=seconds=>`${Math.floor(seconds/60)}:${String(Math.floor(seconds%60)).padStart(2,'0')}`;
  video.addEventListener('timeupdate',()=>{if(!Number.isFinite(video.duration))return;range.value=String(video.currentTime/video.duration*1000);range.setAttribute('aria-valuetext',`${format(video.currentTime)} von ${format(video.duration)}`);time.textContent=`${format(video.currentTime)} / ${format(video.duration)}`;});
  range.addEventListener('input',()=>{if(loaded&&Number.isFinite(video.duration))video.currentTime=Number(range.value)/1000*video.duration;});
  play.addEventListener('click',()=>{
    if(video.paused){startManually();}
    else{userPaused=true;video.pause();}
  });
  sound.addEventListener('click',event=>{
    audioPromptSeen=true;video.muted=false;updateControls();
    if(video.paused){startManually();}
    if(event.detail===0)mute.focus({preventScroll:true});
  });
  mute.addEventListener('click',()=>{video.muted=!video.muted;updateControls();});
  new IntersectionObserver(([entry])=>{near=entry.isIntersecting;if(near)load();},{rootMargin:'450px'}).observe(root);
  new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;syncPlay();updateControls();},{threshold:.15}).observe(screen);
  document.addEventListener('visibilitychange',syncPlay);
  addEventListener('pageshow',syncPlay);reduced.addEventListener('change',syncPlay);
  addEventListener('pagehide',()=>video.pause());
  choose('packing');
})();
